document.addEventListener("DOMContentLoaded", function () {
  // createcloud.* のときだけ動かす
  var host = location.hostname;
  if (
    host !== "createcloud.akapon.jp" &&
    host !== "createcloud.kanritools.com" &&
    host !== "membersbt.createcloud.jp" &&
    host !== "member.createcloud.jp" &&
    host !== "membernew.createcloud.jp" &&
    host !== "member.create-cloud.local"
  ) return;

  // 1回だけ表示（localStorage + cookie）
  var KEY = "cc_integration_modal_hidden";

  // テスト用：?reset=1 で「表示済み」を解除（IPは使わない）
  var params = new URLSearchParams(location.search || "");
  if (params.get("reset") === "1") {
    try { localStorage.removeItem(KEY); } catch(e) {}
    document.cookie = KEY + "=; path=/; max-age=0; SameSite=Lax" + (location.protocol === "https:" ? "; Secure" : "");
  }

  try {
    if (localStorage.getItem(KEY) === "1") return;
  } catch(e) {}

  if (document.cookie.split(";").some(function(c){ return c.trim().indexOf(KEY + "=1") === 0; })) {
    return;
  }

  var overlay = document.getElementById("update-overlay");
  var popup   = document.getElementById("update-popup");
  var btn     = document.getElementById("information_detail-btn");
  var closeBtn = document.getElementById("update-close-btn");

  if (!overlay || !popup) return;

  overlay.style.display = "block";
  popup.style.display = "block";

  // 表示した時点で「2度と表示しない」を確定
  try { localStorage.setItem(KEY, "1"); } catch(e) {}
  document.cookie = KEY + "=1; path=/; max-age=31536000; SameSite=Lax" + (location.protocol === "https:" ? "; Secure" : "");

  function closeModal() {
    popup.style.display = "none";
    overlay.style.display = "none";
  }

  overlay.addEventListener("click", closeModal);

  // ★ 右上✕ボタンで閉じる
  if (closeBtn) {
    closeBtn.addEventListener("click", function(e){
      e.preventDefault();
      e.stopPropagation();
      closeModal();
    });
  }

  // 「詳細はこちら」クリックで閉じてから遷移
  if (btn) {
    btn.addEventListener("click", function(e){
      e.preventDefault();
      var href = btn.getAttribute("href") || "";
      closeModal();
      if (href) location.href = href;
    });
  }
});
